import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function reportsReducer() {
    return combineReducers({
        reportsList: createItemReducer("CarrierHome", "TruckPlanDistributionLogWeb.ListReportSc", false)
    });
}